module.exports = __webpack_public_path__ + "img/1212113.4de4c433.jpg";